import { useNavigate } from 'react-router-dom';

import questionService from '../services/question.service';
import { QuestionEditor } from '../components/question';

const QuestionCreatePage: React.FC = () => {
    const navigate = useNavigate();

    const handleSave = async (question: any, _action: 'draft' | 'publish') => {
        const created = await questionService.createQuestion(question);
        navigate(`/questions/${created._id}/edit`);
    };

    const handleValidateAI = async (question: any) => {
        return await questionService.validateWithAI(question._id || '');
    };

    return (
        <div className="max-w-7xl mx-auto">
            <QuestionEditor onSave={handleSave} onCancel={() => navigate('/questions')} onValidateAI={handleValidateAI} />
        </div>
    );
};

export default QuestionCreatePage;
